<template>
  <div class="coupon" v-if="data" v-clickOutside="onClickOutside">
    <div @click="showCouponList($event)" ref="coupon" class="coupon__content">
      <img class="coupon__logo" src="../images/coupon.png" />
      <div class="coupon__items">
        <div class="coupon__item" v-for="(item, index) in data.list" :key="index">
          <span class="coupon__item__text">{{ item.title }}</span>
        </div>
      </div>
      <img
        class="coupon__arrows"
        src="../images/coupon_down.png"
        :class="{ 'arrows-rotate': showList }"
      />
    </div>
    <div
      class="coupon__list coupon-list-style"
      v-if="couponList && couponList.length > 0 && showList"
    >
      <div class="coupon__list__items">
        <div class="coupon__list__item" v-for="(item, index) in couponList" :key="index">
          <div class="item-left">
            <p class="left-price">
              <span class="left-price__logo">{{ item.moneyIcon }}</span>
              <span class="left-price__number">{{ computedText(item.faceText) }}</span>
              <span class="left-price__discount" v-if="!item.moneyIcon">折</span>
            </p>
            <p>{{ item.reduceText }}</p>
          </div>
          <div class="item-content">
            <p class="content-detail">{{ item.name }}</p>
            <p class="content-time">{{ item.validDate }}</p>
          </div>
          <div class="item-right">
            <div v-if="Number(item.status) === 1" class="item-right__getNotAll">
              <p class="right-button" @click.stop="handleGetCoupon($event, item)">
                {{ item.buttonText }}
              </p>
              <p class="coupons-left-num">{{ item.getedText }}</p>
            </div>
            <div v-if="Number(item.status) === 2" class="item-right__getAll">
              <img src="../images/received.png" class="item-right__img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import types from '@/views/NewCourseDetail/store/types'
import { mapState, mapActions } from 'vuex'
import clickOutside from '@/util/clickOutside'
import ConfirmDialog from '@/components/ConfirmDialog'
import builder from '@/modules/dialog-builder'
export default {
  props: ['data', 'courseId'],
  data() {
    return {
      showList: false,
      canClick: true,
      message: '出了点问题，再试一次吧'
    }
  },
  directives: {
    clickOutside // 注册自定义事件
  },
  async mounted() {
    const params = {
      eventname: 'exposure',
      key: 'coupon-module-show',
      couponid:
        this.data &&
        this.data.list &&
        this.data.list
          .filter(item => item)
          .map(item => item.id)
          .join(',')
    }
    this.$xesLogger.loadMsg(params)
  },
  computed: {
    ...mapState({
      couponList: state => state.NewCourseDetail.couponList,
      courseDetail: state => state.NewCourseDetail.courseDetail,
      couponMessage: state => state.NewCourseDetail.couponMessage
    })
  },
  methods: {
    ...mapActions({
      getCouponList: types.GET_NEW_COUPON_LIST,
      getCoupon: types.GET_NEW_COUPON
    }),
    async showCouponList(event) {
      const params = {
        eventname: 'click',
        key: 'click-coupon-module',
        couponid:
          this.data &&
          this.data.list &&
          this.data.list
            .filter(item => item)
            .map(item => item.id)
            .join(',')
      }
      this.$xesLogger.clickMsg({params: params})
      if (!this.showList) {
        await this.getCouponList({ courseId: this.courseId })
        if (this.couponList && this.couponList.length === 0) {
          const confirmDialog = builder(ConfirmDialog, this.$router, this.$store)
          await confirmDialog({ data: this.message })
        } else {
          this.showList = true
        }
        const _params = {
          eventname: 'exposure',
          key: 'coupon-list-show',
          coupons:
            this.couponList.length > 0 &&
            this.couponList
              .filter(item => item)
              .map(item => {
                return { couponid: item.id, status: item.status }
              })
        }
        this.$xesLogger.loadMsg(_params)
        return
      }
      this.showList = false
    },
    async handleGetCoupon(event, item) {
      if (!this.canClick) return
      this.canClick = false
      await this.getCoupon({ couponId: item.id, courseId: this.courseId })
      this.canClick = true
      if (this.couponMessage) {
        const confirmDialog = builder(ConfirmDialog, this.$router, this.$store)
        await confirmDialog({ data: this.couponMessage })
      }
      const params = {
        eventname: 'click',
        key: 'click-get-coupon',
        couponid: item.id,
        status: 1
      }
      this.$xesLogger.clickMsg({params: params})
    },
    computedText(str) {
      if (str && typeof str === 'string') {
        return str.charAt(str.length - 1) === '折' ? str.substr(0, str.length - 1) : str
      }
    },
    onClickOutside() {
      if (this.showList) {
        this.showList = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@include b(coupon) {
  position: relative;
  font-family: PingFangSC-Semibold, PingFang SC;
  @include e(content) {
    & > span,
    img {
      display: inline-block;
    }
    width: 320px;
    height: 20px;
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  @include e(logo) {
    width: 42px;
    height: 16px;
  }
  @include e(item) {
    position: relative;
    display: inline-block;
    height: 20px;
    margin-right: 8px;
    @include e(text) {
      display: inline-block;
      margin: 0 7px;
      color: #f13232;
      font-size: 12px;
      line-height: 20px;
      height: 20px;
      background-image: url('../images/coupon_bg.png');
      background-size: 200% 20px;
      background-repeat: no-repeat;
      background-position: center;
      position: relative;
      &::after {
        content: '';
        display: block;
        width: 7px;
        height: 100%;
        background-image: url('../images/coupon_bg.png');
        background-repeat: no-repeat;
        background-size: auto 20px;
        background-position: center right;
        position: absolute;
        right: -7px;
        top: 50%;
        transform: translateY(-50%);
      }
      &::before {
        content: '';
        display: block;
        width: 7px;
        height: 100%;
        background-image: url('../images/coupon_bg.png');
        background-repeat: no-repeat;
        background-size: auto 20px;
        background-position: center left;
        position: absolute;
        left: -7px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  @include e(items) {
    width: 240px;
    margin-left: 24px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  @include e(arrows) {
    height: 6px;
    width: 10px;
    vertical-align: middle;
    margin-right: 4px;
  }
  @include e(go) {
    font-size: 12px;
    margin-right: 12px;
  }
  @include e(list) {
    position: absolute;
    z-index: 99;
    box-sizing: border-box;
    top: 0px;
    left: 0px;
    width: 412px;
    padding: 20px 0;
    background: #ffffff;
    @include e(items) {
      padding: 0 16px;
      max-height: 428px;
      overflow-y: auto;
      overflow-x: hidden;
      margin-top: -12px;
    }
    @include e(item) {
      width: 380px;
      height: 70px;
      background: url('../images/coupon_item_bg.png');
      background-size: 100% 70px;
      background-repeat: no-repeat;
    }
  }
}
.coupon__list__item {
  & > div {
    display: inline-block;
    box-sizing: border-box;
  }
  margin-top: 12px;
  display: flex;
  align-items: center;
  .item-left {
    width: 96px;
    height: 100%;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    .left-price {
      font-weight: 600;
      margin-top: 11px;
      & > span {
        display: inline-block;
      }
      .left-price__logo {
        font-size: 13px;
        margin-right: 2px;
      }
      .left-price__number {
        font-size: 28px;
      }
      .left-price__discount {
        margin-left: 2px;
      }
    }
    .item-threshold {
      font-size: 12px;
    }
  }
  .item-content {
    width: 212px;
    font-size: 12px;
    color: #f13232;
    padding: 12px;
    .content-time {
      margin-top: 6px;
      overflow: hidden;
      white-space: nowrap;
    }
    .content-detail {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .item-right {
    width: 72px;
    font-size: 12px;
    .right-button {
      width: 64px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      background: #f13232;
      color: #ffffff;
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        background: #fa4747;
      }
      &:active {
        background: #d42525;
      }
    }
    .item-right__getAll {
      position: relative;
      height: 70px;
    }
    .item-right__getNotAll {
      width: 64px;
      height: 28px;
      position: relative;
      margin-right: 8px;
    }
    .item-right__img {
      position: absolute;
      right: 8px;
      bottom: 8px;
      height: 42px;
      width: 44px;
    }
    .coupons-left-num {
      width: 64px;
      color: #f13232;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: -14px;
    }
  }
}
.coupon-list-style {
  left: -46px;
  top: 30px;
  box-shadow: 0px 0px 16px 0px rgba(229, 229, 229, 0.6);
  border-radius: 2px;
  &::before {
    right: 44px;
    pointer-events: none;
    position: absolute;
    display: block;
    content: '';
    width: 0;
    height: 0;
    border: 11px dashed transparent;
    z-index: 1;
    border-bottom-style: solid;
    border-width: 0 11px 11px;
    border-bottom-color: #e5e5e5;
    bottom: 0;
    top: -11px;
  }
  &::after {
    right: 44px;
    pointer-events: none;
    position: absolute;
    display: block;
    content: '';
    width: 0;
    height: 0;
    border: 11px dashed transparent;
    z-index: 1;
    border-bottom-style: solid;
    border-width: 0 11px 11px;
    top: -10px;
    border-bottom-color: #ffffff;
    bottom: -1px;
  }
}
.arrows-rotate {
  transform: rotate(180deg);
}
.alert__dialog__toast {
  position: fixed;
  z-index: 2000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s;
  text-align: center;
  border-radius: 5px;
  color: #fff;
  background: rgba(17, 17, 17, 0.7);
  font-size: 16px;
  height: 48px;
  line-height: 48px;
  padding: 0 15px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/DetailCoupon.vue